import { Button, DataSource, HorizontalSpacer, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiCustomTransControl extends Layout {
    buttonTestFilename: Button;
    horizontalspacer1: HorizontalSpacer;
    sourceCustomTransControl: DataSource;
    tableFilename: Table;
    textboxExtension: Textbox;
    textboxPrefix: Textbox;
    textboxSampleControlNo: Textbox;
}
